import React, { useState } from "react";
import axios from "axios";
import "../Styling/NewHire.css";

function PreJoiningForm() {
  const [formData, setFormData] = useState({
    name: "",
    rank: "",
    dateOfBirth: "",
    nationality: "",
    passportNumber: "",
    passportExpiry: "",
    cdcNumber: "",
    cdcExpiry: "",
    isEligible: false,
    lastCompanyName: "",
    referenceDetails: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  return (
    <div className="container">
      <h1>New Hire - Pre-Joining</h1>

      <form>
        <div className="card">
          <h3>Personal & Identity Details</h3>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                id="name"
                name="name"
                placeholder="Enter full name"
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="rank">Rank</label>
              <input
                id="rank"
                name="rank"
                placeholder="Select Rank"
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="dateOfBirth">Date of Birth</label>
              <input
                type="date"
                id="dateOfBirth"
                name="dateOfBirth"
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="nationality">Nationality</label>
              <input
                id="nationality"
                name="nationality"
                placeholder="Select Nationality"
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="passportNumber">Passport Number</label>
              <input
                id="passportNumber"
                name="passportNumber"
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="passportExpiry">Passport Expiry</label>
              <input
                type="date"
                id="passportExpiry"
                name="passportExpiry"
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="cdcNumber">CDC Number</label>
              <input id="cdcNumber" name="cdcNumber" onChange={handleChange} />
            </div>

            <div className="form-group">
              <label htmlFor="cdcExpiry">CDC Expiry</label>
              <input
                type="date"
                id="cdcExpiry"
                name="cdcExpiry"
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
         
         <div className="card">
            <h3>Induction Eligibility</h3>
        <div className="form-row">
          <div className="form-group checkbox-group">
            <label>
              <input
                type="checkbox"
                name="isEligible"
                checked={formData.isEligible}
                onChange={handleChange}
              />
              All documents valid for induction
            </label>
          </div>
        </div>
        </div>

        <div className="card">
          <h3>Previous Company</h3>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="lastCompanyName">Last Company Name</label>
              <input
                id="lastCompanyName"
                name="lastCompanyName"
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="referenceDetails">
                Reference Contact Details
              </label>
              <input
                id="referenceDetails"
                name="referenceDetails"
                placeholder="Phone / Email / Notes"
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <button type="submit" className="save-btn">
          Save & Generate Induction Number
        </button>
      </form>
    </div>
  );
}

export default PreJoiningForm;
